import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, Navigate } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import SimilarProjects from './../Elements/SimilarProjects';
import Banner from './../Elements/Banner';
import ReactPlayer from 'react-player';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnrimg = require('./../../images/banner/5.jpg');

const ProjectDetail = () => {
    const location = useLocation();
    const projectSlug = location.state?.projectSlug;
    
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [activeModalVideo, setActiveModalVideo] = useState(null);
    const [selectedVideoIndex, setSelectedVideoIndex] = useState(0);
    const [topViewMode, setTopViewMode] = useState('video'); // 'video' or 'image'

    useEffect(() => {
        if (!projectSlug) {
            setLoading(false);
            setError(true);
            return;
        }

        setSelectedVideoIndex(0);
        setTopViewMode('video');

        axiosClient.get(apiConfig.PROJECTS.GET_ONE(projectSlug))
            .then(res => {
                setProject(res.data.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError(true);
                setLoading(false);
            });
    }, [projectSlug]);

    if (error) {
        return <Navigate to="/project-grid" />;
    }

    if (loading || !project) {
        return (
            <>
                <Header />
                <div className="page-content">
                    <div className="section-full p-tb80 inner-page-padding text-center">
                        Loading...
                    </div>
                </div>
                <Footer />
            </>
        );
    }

    const hasVideos = project.videos && project.videos.length > 0;

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title="Helping you and your house become better acquainted." pagename="Project Detail" bgimage={bnrimg} />

                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        <div className="project-detail-outer">
                            <div className="m-b0">
                                <div className="row">
                                    {(project.images || []).map((img, index) => (
                                        <div key={index} className="col-md-4 col-sm-4">
                                            <div className="project-detail-pic m-b30">
                                                <div className="mt-media">
                                                    <img src={img.url} alt={`${project.title} gallery ${index + 1}`} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="m-b30">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="product-block">
                                            <div className="row">
                                                <div className="col-md-12 m-b10">
                                                    <h4 className="text-uppercase font-weight-600 m-b10">Date</h4>
                                                    <p>{project.completion_date || project.date || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-12 m-b10">
                                                    <h4 className="text-uppercase font-weight-600 m-b10">Client</h4>
                                                    <p>{project.client_name || project.client || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-12 m-b10">
                                                    <h4 className="text-uppercase font-weight-600 m-b10">Project type</h4>
                                                    <p>{project.service?.name || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-12 m-b10">
                                                    <h4 className="text-uppercase font-weight-600 m-b10">Location</h4>
                                                    <p>{project.location || 'N/A'}</p>
                                                </div>
                                                <div className="col-md-12 m-b10">
                                                    <h4 className="text-uppercase font-weight-600 m-b10">Year</h4>
                                                    <p>{(project.completion_date || project.date) ? new Date(project.completion_date || project.date).getFullYear() : 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-8">
                                        {hasVideos && topViewMode === 'video' ? (
                                            <div className="project-top-video-wrapper" style={{
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                                                backgroundColor: '#000',
                                            }}>
                                                {/* Top Mode Selector if image exists */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '8px 12px',
                                                    backgroundColor: '#1b1b1b',
                                                    borderBottom: '1px solid #2a2a2a'
                                                }}>
                                                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                                        <span style={{ color: '#fff', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }} className="text-primary">
                                                            🎥 Project Video {project.videos.length > 1 ? `(${selectedVideoIndex + 1}/${project.videos.length})` : ''}
                                                        </span>
                                                        {project.videos.length > 1 && (
                                                            <div style={{ display: 'flex', gap: '4px', marginLeft: '6px' }}>
                                                                {project.videos.map((_, idx) => (
                                                                    <button
                                                                        key={idx}
                                                                        type="button"
                                                                        onClick={() => setSelectedVideoIndex(idx)}
                                                                        className={`btn btn-xs ${selectedVideoIndex === idx ? 'btn-primary' : 'btn-default'}`}
                                                                        style={{ padding: '1px 6px', fontSize: '10px' }}
                                                                    >
                                                                        #{idx + 1}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {project.featured_image && (
                                                        <button
                                                            type="button"
                                                            onClick={() => setTopViewMode('image')}
                                                            className="btn btn-default btn-xs"
                                                            style={{ fontSize: '10px', padding: '2px 8px' }}
                                                        >
                                                            🖼️ View Photo
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Active Video Player */}
                                                <div style={{ position: 'relative', paddingTop: '56.25%', backgroundColor: '#000' }}>
                                                    <ReactPlayer
                                                        key={project.videos[selectedVideoIndex]?.url}
                                                        url={project.videos[selectedVideoIndex]?.url}
                                                        controls
                                                        width="100%"
                                                        height="100%"
                                                        style={{ position: 'absolute', top: 0, left: 0 }}
                                                        config={{
                                                            file: {
                                                                attributes: {
                                                                    controlsList: 'nodownload'
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>

                                                {/* Title / Caption under Player */}
                                                {(project.videos[selectedVideoIndex]?.title || project.videos[selectedVideoIndex]?.caption) && (
                                                    <div style={{ padding: '10px 14px', backgroundColor: '#161616', color: '#fff' }}>
                                                        {project.videos[selectedVideoIndex]?.title && (
                                                            <h5 style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: '#fff' }}>
                                                                {project.videos[selectedVideoIndex].title}
                                                            </h5>
                                                        )}
                                                        {project.videos[selectedVideoIndex]?.caption && (
                                                            <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#aaa' }}>
                                                                {project.videos[selectedVideoIndex].caption}
                                                            </p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="mt-box">
                                                <div className="mt-thum-bx mt-img-overlay1 mt-img-effect yt-thum-box">
                                                    <img src={project.featured_image} alt={project.title} />
                                                    {hasVideos && (
                                                        <button
                                                            type="button"
                                                            className="play-now"
                                                            onClick={() => setTopViewMode('video')}
                                                            title="Watch Project Video"
                                                        >
                                                            <i className="icon fa fa-play" />
                                                            <span className="ripple" />
                                                        </button>
                                                    )}
                                                </div>
                                                {hasVideos && topViewMode === 'image' && (
                                                    <div className="text-right m-t10">
                                                        <button
                                                            type="button"
                                                            onClick={() => setTopViewMode('video')}
                                                            className="site-button btn-xs"
                                                            style={{ fontSize: '11px' }}
                                                        >
                                                            🎥 Switch to Video
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="project-detail-containt">
                                <div className="bg-white text-black">
                                    <h3 className="font-weight-600">{project.title}</h3>
                                    <p>{project.description}</p>
                                    <div className="m-b0">
                                        <div className="mt-divider divider-1px bg-black"><i className="icon-dot c-square" /></div>
                                    </div>
                                    <ul className="social-icons social-square social-darkest m-b0">
                                        <li><NavLink to={"#"} className="fa fa-facebook" /></li>
                                        <li><NavLink to={"#"} className="fa fa-twitter" /></li>
                                        <li><NavLink to={"#"} className="fa fa-linkedin" /></li>
                                        <li><NavLink to={"#"} className="fa fa-rss" /></li>
                                        <li><NavLink to={"#"} className="fa fa-youtube" /></li>
                                        <li><NavLink to={"#"} className="fa fa-instagram" /></li>
                                    </ul>
                                </div>
                            </div>

                            {/* ── Project Videos Gallery ── */}
                            {hasVideos && (
                                <div id="project-videos-section" className="m-t50">
                                    <div className="section-head">
                                        <div className="mt-separator-outer separator-left">
                                            <div className="mt-separator">
                                                <h3 className="text-uppercase sep-line-one">
                                                    <span className="font-weight-300 text-primary">Project</span> Videos ({project.videos.length})
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {project.videos.map((video, index) => (
                                            <div key={video.id || index} className="col-md-6 col-sm-12 m-b30">
                                                <div className="project-video-card" style={{
                                                    borderRadius: '8px',
                                                    overflow: 'hidden',
                                                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                                                    backgroundColor: '#111',
                                                }}>
                                                    <div style={{ position: 'relative', paddingTop: '56.25%', backgroundColor: '#000' }}>
                                                        <ReactPlayer
                                                            url={video.url}
                                                            controls
                                                            width="100%"
                                                            height="100%"
                                                            style={{ position: 'absolute', top: 0, left: 0 }}
                                                            config={{
                                                                file: {
                                                                    attributes: {
                                                                        controlsList: 'nodownload'
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {(video.title || video.caption) && (
                                                        <div style={{
                                                            padding: '16px 20px',
                                                            backgroundColor: '#1a1a1a',
                                                            borderTop: '1px solid #2a2a2a'
                                                        }}>
                                                            {video.title && (
                                                                <h5 style={{ margin: '0 0 6px 0', fontWeight: 600, color: '#fff', fontSize: '16px' }}>
                                                                    {video.title}
                                                                </h5>
                                                            )}
                                                            {video.caption && (
                                                                <p style={{ margin: 0, fontSize: '14px', color: '#aaa', lineHeight: '1.5' }}>
                                                                    {video.caption}
                                                                </p>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* Similar projects fetched dynamically from API */}
                <SimilarProjects
                    currentProjectSlug={project.slug}
                    serviceSlug={project.service?.slug}
                />
            </div>

            {/* Modal for featured video player */}
            {hasVideos && (
                <div className="modal fade" id="videoModal" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content" style={{ backgroundColor: '#000', border: 'none' }}>
                            <div className="modal-header" style={{ border: 'none', padding: '10px 15px' }}>
                                <button type="button" className="close" data-dismiss="modal" style={{ color: '#fff', opacity: 0.8 }} onClick={() => setActiveModalVideo(null)}>
                                    &times;
                                </button>
                                {activeModalVideo?.title && (
                                    <h4 className="modal-title" style={{ color: '#fff' }}>{activeModalVideo.title}</h4>
                                )}
                            </div>
                            <div className="modal-body" style={{ padding: 0 }}>
                                <div style={{ position: 'relative', paddingTop: '56.25%', backgroundColor: '#000' }}>
                                    {activeModalVideo && (
                                        <ReactPlayer
                                            url={activeModalVideo.url}
                                            controls
                                            playing={true}
                                            width="100%"
                                            height="100%"
                                            style={{ position: 'absolute', top: 0, left: 0 }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </>
    );
};

export default ProjectDetail;
